// CartHub Dashboard — Brands Component.
// Brand Intelligence: lista brand, analytics enrichment, catalogo globale.

import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { api, Ic } from "../shared";

const CATALOG_KEYS = [
  { key: "catElectronics", n: 40 },
  { key: "catSportswear", n: 35 },
  { key: "catFashion", n: 35 },
  { key: "catBeauty", n: 25 },
  { key: "catHome", n: 20 },
  { key: "catAutomotive", n: 20 },
  { key: "catSupplements", n: 20 },
  { key: "catFood", n: 31 },
  { key: "catToys", n: 15 },
];

export default function Brands({ shopId }) {
  const { t } = useTranslation("brands");
  const [tab, setTab] = useState("brands");
  const [search, setSearch] = useState("");
  const [brands, setBrands] = useState([]);

  useEffect(() => {
    if (!shopId) return;
    api(`/brands/${shopId}`)
      .then((d) => setBrands(Array.isArray(d) ? d : []))
      .catch(() => {});
  }, [shopId]);

  const list = brands.filter((b) => b.brand_name.toLowerCase().includes(search.toLowerCase()));
  const maxEnrichment = Math.max(...brands.map((b) => b.times_enriched || 0), 1);

  return (
    <div>
      <div className="ch-tabs">
        {[
          ["brands", t("tabs.brands")],
          ["analytics", t("tabs.analytics")],
          ["catalogo", t("tabs.catalog")],
        ].map(([k, v]) => (
          <div key={k} className={`ch-tab${tab === k ? " active" : ""}`} onClick={() => setTab(k)}>
            {v}
          </div>
        ))}
      </div>
      {tab === "brands" && (
        <>
          <div className="ch-info">
            <strong>{t("info.howLabel")}</strong> {t("info.howBody")}
          </div>
          <div className="ch-card" style={{ padding: 0 }}>
            <div className="brands-list-toolbar" style={{ padding: "12px 14px", borderBottom: "1px solid #e5e5e5" }}>
              <input className="ch-search" placeholder={t("searchPlaceholder")} value={search} onChange={(e) => setSearch(e.target.value)} />
              <span style={{ fontSize: 14, color: "#9ca3af", marginLeft: "auto" }}>{t("brandCount", { count: list.length })}</span>
            </div>
            <div className="ch-brands-table-wrap">
              <div className="ch-brands-header">
                <div />
                <div>{t("table.brand")}</div>
                <div>{t("table.website")}</div>
                <div>{t("table.enrichment")}</div>
                <div>{t("table.status")}</div>
              </div>
              {list.map((b) => (
                <div key={b.id} className="ch-brand-row">
                  <div className="brand-av">{b.brand_name[0]}</div>
                  <div>
                    <div style={{ fontWeight: 500 }}>{b.brand_name}</div>
                    <div className="td-sm">{b.category_slug}</div>
                  </div>
                  <div style={{ fontSize: 14, color: "#6b7280" }}>{b.official_website.replace("https://", "")}</div>
                  <div style={{ fontSize: 14, color: "#6b7280" }}>{t("table.enrichedTimes", { count: b.times_enriched || 0 })}</div>
                  <div>
                    <span className={`ch-status${b.active ? " success" : " neutral"}`}>{b.active ? t("table.active") : t("table.inactive")}</span>
                  </div>
                </div>
              ))}
            </div>
            {list.length === 0 && (
              <div className="empty" style={{ padding: 24 }}>
                <div>{t("emptyList")}</div>
              </div>
            )}
            <div style={{ padding: "12px 14px", borderTop: "1px solid #e5e5e5" }}>
              <div className="ch-info" style={{ marginBottom: 0 }}>
                {t("footer.before")}
                <strong>{t("footer.brandTab")}</strong>
                {t("footer.after")}
              </div>
            </div>
          </div>
        </>
      )}
      {tab === "analytics" && (
        <div className="grid-2">
          <div className="ch-card">
            <h2>{t("analytics.enrichmentTitle")}</h2>
            <p>{t("analytics.enrichmentSubtitle")}</p>
            {brands
              .filter((b) => (b.times_enriched || 0) > 0)
              .map((b) => (
                <div key={b.id} style={{ marginBottom: 14 }}>
                  <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 5 }}>
                    <span style={{ fontSize: 15, fontWeight: 500 }}>{b.brand_name}</span>
                    <span style={{ fontSize: 14, color: "#0A85CF" }}>×{b.times_enriched}</span>
                  </div>
                  <div className="progress-wrap">
                    <div className="progress-bar" style={{ width: `${((b.times_enriched || 0) / maxEnrichment) * 100}%` }} />
                  </div>
                </div>
              ))}
          </div>
          <div className="ch-card">
            <h2>{t("analytics.impactTitle")}</h2>
            <p>{t("analytics.impactSubtitle")}</p>
            <div style={{ display: "flex", flexDirection: "column", gap: 12, marginBottom: 20 }}>
              {[
                { l: t("analytics.withEnrichment"), v: "34.2%", c: "#2e7d32" },
                { l: t("analytics.withoutEnrichment"), v: "21.7%", c: "#9ca3af" },
              ].map((r) => (
                <div key={r.l} style={{ padding: 14, background: "#f9fafb", borderRadius: 6, border: "1px solid #e5e5e5" }}>
                  <div style={{ fontSize: 14, color: "#6b7280", marginBottom: 4 }}>{r.l}</div>
                  <div style={{ fontSize: 22, fontWeight: 600, color: r.c }}>{r.v}</div>
                </div>
              ))}
            </div>
            <span className="ch-status success">{t("analytics.lift")}</span>
          </div>
        </div>
      )}
      {tab === "catalogo" && (
        <>
          <div className="ch-info">
            <strong>{t("catalog.introBold")}</strong>
            {t("catalog.introRest")}
          </div>
          <div className="grid-3">
            {CATALOG_KEYS.map((c) => (
              <div key={c.key} className="ch-card" style={{ padding: 16, display: "flex", gap: 12, alignItems: "center", marginBottom: 0 }}>
                <div style={{ display: "flex", color: "var(--accent)", flexShrink: 0 }}>
                  <span style={{ display: "flex", width: 22, height: 22 }}>{Ic.tag}</span>
                </div>
                <div>
                  <div style={{ fontWeight: 500, fontSize: 15 }}>{t(`catalog.${c.key}`)}</div>
                  <div style={{ fontSize: 14, color: "#6b7280" }}>{t("catalog.brandsInCategory", { count: c.n })}</div>
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
